var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDialogRefreshGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 76.5,
    r: 70,
    stroke: "#89F3B8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 76.5,
    r: 75,
    stroke: "#89F3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 63.5,
    stroke: "#89F3B8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 76.5C17 43.6391 43.6391 17 76.5 17C109.361 17 136 43.6391 136 76.5C136 109.361 109.361 136 76.5 136C43.6391 136 17 109.361 17 76.5Z",
    fill: "url(#paint0_linear_186_12271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.469 51.2188V69.5C106.469 70.6849 106.088 71.6582 105.326 72.4199C104.564 73.1816 103.591 73.5625 102.406 73.5625H84.125C82.9401 73.5625 81.9668 73.1816 81.2051 72.4199C80.4434 71.6582 80.0625 70.6849 80.0625 69.5C80.0625 68.3151 80.4434 67.3418 81.2051 66.5801C81.9668 65.8184 82.9401 65.4375 84.125 65.4375H92.123C90.1764 62.8984 87.8066 60.9095 85.0137 59.4707C82.2207 58.0319 79.2161 57.3125 76 57.3125C70.2448 57.4818 65.4629 59.4707 61.6543 63.2793C57.8457 67.0879 55.8568 71.8698 55.6875 77.625C55.8568 83.3802 57.8457 88.1621 61.6543 91.9707C65.4629 95.7793 70.2448 97.7682 76 97.9375C80.4857 97.9375 84.5482 96.5833 88.1875 93.875C89.1185 93.1979 90.0918 92.944 91.1074 93.1133C92.2077 93.2826 93.0964 93.7904 93.7734 94.6367C94.4505 95.5677 94.7467 96.5833 94.6621 97.6836C94.4928 98.7839 93.9427 99.6725 93.0117 100.35C87.9336 104.074 82.263 105.978 76 106.062C70.668 105.978 65.8861 104.666 61.6543 102.127C57.4225 99.5879 54.0371 96.2025 51.498 91.9707C48.959 87.6543 47.6471 82.8724 47.5625 77.625C47.6471 72.3776 48.959 67.5957 51.498 63.2793C54.0371 59.0475 57.4225 55.6621 61.6543 53.123C65.8861 50.584 70.668 49.2721 76 49.1875C80.401 49.1875 84.5482 50.1608 88.4414 52.1074C92.3346 54.054 95.6354 56.7201 98.3438 60.1055V51.2188C98.3438 50.0339 98.7246 49.0605 99.4863 48.2988C100.248 47.5371 101.221 47.1562 102.406 47.1562C103.591 47.1562 104.564 47.5371 105.326 48.2988C106.088 49.0605 106.469 50.0339 106.469 51.2188Z",
    fill: "url(#paint1_linear_186_12271)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_12271",
    x1: 76.5,
    y1: 17,
    x2: 76.5,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_12271",
    x1: 62.6607,
    y1: 40.9375,
    x2: 62.6607,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260076,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3FFD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogRefreshGreen);
export default __webpack_public_path__ + "static/media/img_dialog_refresh_green.f26fe196fc46092abe9ac13025b5dc9f.svg";
export { ForwardRef as ReactComponent };